import moment from 'moment'
export default {
  methods: {
    regularDateFormat(value) {
      if(value){
        return moment(String(value)).locale("es").format('DD/MM/YYYY')
      }
    },
    midDateFormat(value) {
      if(value){
        return moment(String(value)).locale("es").format('DD [de] MMMM [de] YYYY')
      }
    },
    daysAgo(value) {
      if(value){
        return moment(String(value)).locale("es").startOf('day').fromNow(); 
      }
    },
  }
}